import React from "react";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface props {
  name: string;
  qty?: number;
  color?: string;
  shieldColor?: string;
  icon: JSX.Element;
  tooltip?: string | undefined;
  url?: string | undefined;
  loading?: boolean;
}

export default function ShieldCard({
  name,
  qty,
  color = "bg-secondary-subtle",
  shieldColor,
  icon,
  tooltip,
  url,
  loading = false,
}: props) {
  return url ? (
    <Link className="text-decoration-none" to={`${url || ""}`}>
      <div
        className={`position-relative ${color} p-3 pe-5 pb-md-4 shield-card`}
      >
        <h3 className="shield-card-title">{name}</h3>
        {loading ? (
          <Skeleton height={50}></Skeleton>
        ) : (
          <p className="shield-card-count">{qty ?? "-"}</p>
        )}
        {tooltip ? (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={tooltip}>{tooltip}</Tooltip>}
          >
            <div className={`icon-cont ${shieldColor} position-absolute`}>
              {icon}
            </div>
          </OverlayTrigger>
        ) : (
          <div className={`icon-cont ${shieldColor} position-absolute`}>
            {icon}
          </div>
        )}
      </div>
    </Link>
  ) : (
    <div className={`position-relative ${color} p-3 pe-5 pb-md-4 shield-card`}>
      <h3 className="shield-card-title">{name}</h3>
      {loading ? (
        <Skeleton height={50}></Skeleton>
      ) : (
        <p className="shield-card-count">{qty ?? "-"}</p>
      )}
      {tooltip ? (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={tooltip}>{tooltip}</Tooltip>}
        >
          <div className={`icon-cont ${shieldColor} position-absolute`}>
            {icon}
          </div>
        </OverlayTrigger>
      ) : (
        <div className={`icon-cont ${shieldColor} position-absolute`}>
          {icon}
        </div>
      )}
    </div>
  );
}
